/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-06 11:07:53
 * @LastEditors: Jack Deng
 * @LastEditTime: 2023-03-13 19:19:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/FlashSale/index.tsx
 */
import { SectionCollapse } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Table from './Table';
import styles from './style.module.less';
import { processFlashSaleProducts } from './tool';
function FlashSale(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const { saleChannelUuid = '' } = useParams() as any;
  //
  const _flashSaleProducts = processFlashSaleProducts(data) || [];
  // const { products };
  //console.log('_flashSaleProducts', _flashSaleProducts);
  const noProducts =
    _flashSaleProducts.reduce((pre, now) => {
      const lenP = (now.products || []).length;
      return pre + lenP;
    }, 0) === 0;
  //const {}
  const noData = _flashSaleProducts.length === 0 || noProducts;
  const renderContent = () => {
    return (
      <div className={styles.content}>
        {noData ? (
          <div className={styles.placeholder}>
            {getI18n(
              'salesChannelProductDetail.index.noflashsaleofthisproduct',
            )}
          </div>
        ) : (
          _flashSaleProducts.map((i, index) => {
            return <Table data={i} key={index} />;
          })
        )}
        {/* // <div className={styles.placeholder}>No flash sale of this product</div> */}

        {renderBottom()}
      </div>
    );
  };

  const renderBottom = () => {
    return (
      <Configuration
        configStart={getI18n('general.gotoStore')}
        configLink={getI18n('general.discount')}
        linkTo={`/salesChannel/discounts/flashSale/list/${saleChannelUuid}`}
        configEnd={getI18n('salesChannelProductDetail.index.tomanageflashsale')}
      />
    );
  };
  return (
    <div className={styles.container}>
      <SectionCollapse
        open={true}
        id={'flash-sale'}
        titleStyle={{ height: '64px' }}
        title={
          <div className={'collapseTitle'}>
            {getI18n('general.sider.flashSale')}
          </div>
        }
        content={renderContent()}
        openMargin={16}
      />
    </div>
  );
}

export default FlashSale;
